import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    staticClass: "warehouse-importer-add-edit-modal",
    attrs: {
      "data-sign": "wrapper_inbound_add_edit_modal",
      "width": 1000,
      "title": _vm.rowData.title
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "rules": _vm.formDataRule,
      "data-sign": "wrapper_inbound_add_edit_form",
      "model": _vm.formData,
      "label-col": {
        span: _vm.colSpan
      },
      "wrapper-col": {
        span: 24 - _vm.colSpan
      }
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5165\u5E93\u4ED3\u5E93\uFF08\u533A\u57DF\uFF09"),
      "prop": "warehouse_code",
      "label": _vm.t('入库仓库（区域）')
    }
  }, [_c('my-select', {
    staticClass: "input-item",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "show-search": "",
      "placeholder": _vm.t('请选择入库仓库（区域）')
    },
    model: {
      value: _vm.formData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "warehouse_code", $$v);
      },
      expression: "formData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code,
      attrs: {
        "value": item.warehouse_code
      }
    }, [_vm._v(" " + _vm._s(item.warehouse_name_text) + " ")]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8017\u6750\u7C7B\u578B"),
      "prop": "consumable_type",
      "label": _vm.t('耗材类型')
    }
  }, [_c('my-select', {
    staticClass: "input-item",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择耗材类型')
    },
    on: {
      "change": _vm.handleConsumableTypeChange
    },
    model: {
      value: _vm.formData.consumable_type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "consumable_type", $$v);
      },
      expression: "formData.consumable_type"
    }
  }, _vm._l(_vm.consumableTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.int_value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5907\u6CE8\u4FE1\u606F"),
      "prop": "remark",
      "label": _vm.t('备注信息')
    }
  }, [_c('my-input', {
    staticClass: "input-item",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入备注信息')
    },
    model: {
      value: _vm.formData.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "remark", $$v);
      },
      expression: "formData.remark"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8017\u6750\u4FE1\u606F")
    }
  }, [_c('span', {
    staticClass: "required-tag",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.t('耗材信息')) + " "), _c('a-popover', [_c('template', {
    slot: "content"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.t('请输入审核通过的耗材编码')) + " ")])]), _c('a-icon', {
    staticClass: "mr-5",
    attrs: {
      "type": "question-circle"
    }
  })], 2)], 1), _c('div', {
    staticClass: "package-info"
  }, [_c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "board_no"
    }
  }, [_c('a-input-number', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入箱数/卡板数'),
      "min": 1
    },
    model: {
      value: _vm.detailItem.board_no,
      callback: function ($$v) {
        _vm.$set(_vm.detailItem, "board_no", $$v);
      },
      expression: "detailItem.board_no"
    }
  })], 1), _c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "package_code"
    }
  }, [_c('request-auto-complete', {
    staticClass: "input-item",
    attrs: {
      "searchFunction": _vm.handleSearchPackageList,
      "beforeSearchFun": _vm.beforeSearchFun,
      "placeholder": _vm.t('请输入已选择耗材类型下的耗材编码（支持模糊查询）')
    },
    on: {
      "select": _vm.handleSelectPackage,
      "blur": _vm.handlePackageBlur
    },
    model: {
      value: _vm.detailItem.consumable_code,
      callback: function ($$v) {
        _vm.$set(_vm.detailItem, "consumable_code", $$v);
      },
      expression: "detailItem.consumable_code"
    }
  }, [_c('template', {
    slot: "dataSource"
  }, _vm._l(_vm.wrapperList, function (item) {
    return _c('a-select-option', {
      key: item.consumable_code,
      attrs: {
        "value": item.consumable_code
      }
    }, [_vm._v(_vm._s(item.consumable_code))]);
  }), 1)], 2)], 1), _c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "consumable_num"
    }
  }, [_c('a-input-number', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入数量'),
      "min": 1
    },
    model: {
      value: _vm.detailItem.consumable_num,
      callback: function ($$v) {
        _vm.$set(_vm.detailItem, "consumable_num", $$v);
      },
      expression: "detailItem.consumable_num"
    }
  })], 1), _c('a-button', {
    staticClass: "mb-5",
    attrs: {
      "type": "primary",
      "data-permission": "wrapper_inbound_edit_confirmadd",
      "id": "wrapper_inbound_edit_confirmadd",
      "ghost": "",
      "data-sign": "wrapper_inbound_edit_confirm_add",
      "fbu-analyse-name": $t("\u786E\u8BA4\u6DFB\u52A0")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.t('确认添加')))])], 1)]), _c('my-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "data-source": _vm.formData.detail_list,
      "is-filter-box": "",
      "data-sign": "wrapper_inbound_info_list",
      "row-key": "booking_no",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "operation",
      fn: function (ref) {
        var index = ref.index;
        return _c('div', {}, [_c('a', {
          staticClass: "mr-10",
          attrs: {
            "data-sign": "wrapper_inbound_info_delete",
            "fbu-analyse-name": $t("\u5220\u9664")
          },
          on: {
            "click": function ($event) {
              return _vm.handleDelete(index);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('删除')))])]);
      }
    }])
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "wrapper_inbound_edit_cancel",
      "id": "wrapper_inbound_edit_cancel",
      "data-sign": "wrapper_inbound_add_edit_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "data-permission": "wrapper_inbound_edit_save",
      "id": "wrapper_inbound_edit_save",
      "type": "primary",
      "data-sign": "wrapper_inbound_add_edit_submit",
      "loading": _vm.loading,
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };